<app-modal>
  <h1 class="h2" *ngIf="!showTags">Add RSVPs for {{ data.firstName }}</h1>
  <h1 class="h2" *ngIf="showTags">Add RSVP info</h1>
  <div class="mt-0100 mb-0025">
    <ng-container *ngIf="!showTags">
      <div>
        <div class="event-filters flex col__">
          <div class="flex quicksearch--simple">
            <mat-form-field class="quicksearch--simple__input ongray">
              <mat-label>Search</mat-label>
              <input matInput [formControl]="searchCtrl" type="search" autocomplete="off">
            </mat-form-field>
          </div>
          <mat-form-field class="flex ongray">
            <mat-label>Date range</mat-label>
            <mat-date-range-input [formGroup]="dateRangeFilter" [rangePicker]="customDateRangePicker">
              <input matStartDate (blur)="onDateChange()" formControlName="start" placeholder="Start date">
              <input matEndDate (blur)="onDateChange()" formControlName="end" placeholder="End date">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="customDateRangePicker"></mat-datepicker-toggle>
            <mat-date-range-picker #customDateRangePicker (closed)="onDateChange()"></mat-date-range-picker>
          </mat-form-field>
        </div>
      </div>

      <div class="select-events-container">
        <app-event-list-select [loading]="eventsLoading" [events]="events" [selectedEventIds]="selectedEvents"
          (selectedEvents)="selectedEvents = $event" [allowSelectAll]="true"></app-event-list-select>
      </div>

    </ng-container>

    <ng-container *ngIf="showTags">
      <p>Expand a row to add info to the RSVP.</p>

      <div class="table rsvp-table">
        <app-event-list [entityId]="data?.entityId" [events]="newRsvpEvents" [expandTagsByDefault]="true"></app-event-list>
      </div>
    </ng-container>

    <div class="row dual-btn-row with-gap mt-0100 flexJustify--end" *ngIf="!showTags">
      <button type="button" class="btn btn--white" (click)="addRsvps(true)"
        [disabled]="isSubmitting || selectedEvents.length === 0">
        RSVP and add info
      </button>
      <button type="button" class="btn mt-0" (click)="addRsvps()"
        [disabled]="isSubmitting || selectedEvents.length === 0">
        RSVP to selected events
      </button>
    </div>
  </div>
</app-modal>
